import axios from 'axios';
import { useMutation, useQuery } from '@tanstack/react-query';
import { noop } from '../lib/serviceHelpers';

// Admin-managed notification recipient lists (new-lead + hand-off alerts).
// One GET carries both lists AND the pickable internal users; PUT replaces
// both lists whole. admin:system_settings only.
export const useFetchNotificationSettings = (opts = {}) => {
  return useQuery(
    ['admin-notification-settings'],
    async () => {
      const res = await axios.get(`/admin/notification-settings`);
      return res.data;
    },
    { refetchOnWindowFocus: false, ...opts },
  );
};

export const useSaveNotificationSettings = (callback, opts = {}) => {
  return useMutation(
    async ({ lists }) => {
      const res = await axios.put(`/admin/notification-settings`, { lists });
      return res.data;
    },
    { ...opts, onSuccess: callback || noop },
  );
};

// Every alert text with sample names, to one typed number (Nic 2026-11-01).
export const useSendNotificationSamples = (opts = {}) => {
  return useMutation(async ({ phone }) => {
    const res = await axios.post(`/admin/notification-settings/samples`, { phone });
    return res.data;
  }, opts);
};
